import * as React from "react"

// components
import Icon from "../components/Icon"
import Menu from "../components/Menu"

// styles
import "../styles/css/styles.css"

// assets
import logo from "../../assets/images/brand/logo.wega.svg"
import argentina from "../../assets/images/icons/flag.argentina.svg"

const Header = () => {
    return(
        <header id="header">
            <div className="container">
                <a href="/"><img src={logo} alt="Wega Motors" /></a>
                <div className="right">
                    <Menu />
                    <Icon link="http://www.wega.com.ar/" title="Wega Argentina" icon={argentina} />
                </div>
            </div>
        </header>
    )
}

export default Header